module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whatis"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("CDP 是什么？")]), _c('p', [_vm._v("CDP （Content Distribution Platform）即内容分配平台，可服务于接入多家 CDN 厂商的用户，实现了按比例灵活调配各 CDN 厂商在不同地区不同运营商中的流量带宽；并能自动收集、监测各 CDN 厂商的节点信息，相互融合，在让域名享受全网都有本地节点覆盖的同时，自动剔除故障节点，保障业务的正常服务。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dc8f093","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/whatis.vue
// module id = 44
// module chunks = 0